<template>
    <b-form class="d-flex flex-column">
        <template v-for="(item) of fields">
            <diverse-input ref="di_input" class="mb-1" :key="item[keyName]" :value.sync="form[item[keyName]]"
                           :config="item"></diverse-input>
        </template>
        <b-overlay :show="loadingItem.size>0 || loading"
                   class="d-flex flex-row position-sticky bottom"
                   spinner-small>
            <mini-button
                variant="success" class="flex-grow-1"
                :disable="!formComplete"
                @click="onSubmit">
                {{ submitLabel }}
            </mini-button>
            <mini-button v-if="enableSubmitContinuous"
                         variant="outline-success" class="ml-1 flex-grow-1"
                         :disable="!formComplete"
                         @click="onSubmit(true)">
                {{ submitContinuousLabel }}
            </mini-button>
        </b-overlay>
    </b-form>
</template>

<script>

import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import formMixin from "@/components/common/inputs/mixin/form-mixin";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput.vue";

export default {
    name: "FormulaForm",
    components: {DiverseInput, MiniButton},
    mixins: [emCommonUtilMixin, formMixin],
    props: {
        submitLabel: {
            type: String,
            default: 'Submit'
        },
        submitContinuousLabel: {
            type: String,
            default: 'Submit Continuous'
        },
        action: {
            type: String,
            default: process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/uploads"
        },
        item: Object,
        keyName: {
            type: String,
            default: 'key'
        },
        loading: Boolean,
        enableSubmitContinuous: Boolean,
    },
    data() {
        return {
            form: {},
            fileMapList: {},
            loadingItem: new Set(),

            hasInit: false,
        }
    },
    computed: {
        formComplete() {
            if (this.hasInit) {
                return this.checkComplete();
            }
            return false;
        },
    },
    created() {
        if (this.item) {
            this.form = this.deepCopyObj(this.item);
        }
    },
    mounted() {
        this.hasInit = true;
    },
    methods: {
        onSubmit(continuous = false) {
            this.$emit('submit' + (continuous ? 'Continuous' : ''), this.form);
        },
        checkComplete() {
            let els = this.$refs.di_input;
            let list = [];
            if (els instanceof Array) {
                list = els;
            } else {
                els && list.push(els);
            }
            for (let el of list) {
                if (el && !el.isValidated()) {
                    return false;
                }
            }
            return true;
        },
    }
}
</script>

<style scoped>
.form-item-cover {
    width: 100%;
}

.form-item-cover >>> .formulate-input-element {
    max-width: 100%;
}

.form-item-cover >>> textarea {
    font-size: .9em !important;
}
</style>
